import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import DepartmentSummaryCard from './DepartmentSummaryCard';

const DeductionsOverview = ({
  activeDepartment,
  isMobile,
  heroTitle,
  heroDescription,
  highlightPrimary,
  highlightSecondary,
  summaryCards
}) => {
  const heroHighlights = [highlightPrimary, highlightSecondary].filter(Boolean);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, delay: 0.1 }}
      >
        <Paper
          sx={{
            p: { xs: 2.5, md: 3 },
            borderRadius: 4,
            mb: 3,
            background: `linear-gradient(135deg, ${activeDepartment.accent} 0%, #111827 135%)`,
            color: 'white',
            boxShadow: '0 18px 45px rgba(15, 23, 42, 0.16)'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', lg: 'row' },
              justifyContent: 'space-between',
              gap: 2.5
            }}
          >
            <Box sx={{ maxWidth: 720 }}>
              <Chip
                label="UI Preview Only"
                size="small"
                sx={{
                  mb: 2,
                  bgcolor: 'rgba(255, 255, 255, 0.14)',
                  color: 'white',
                  fontWeight: 700
                }}
              />
              <Typography variant={isMobile ? 'h5' : 'h4'} sx={{ fontWeight: 700, mb: 1 }}>
                {heroTitle}
              </Typography>
              {heroDescription && (
                <Typography variant="body1" sx={{ maxWidth: 640, color: 'rgba(255,255,255,0.88)' }}>
                  {heroDescription}
                </Typography>
              )}
            </Box>

            {heroHighlights.length > 0 && (
              <Grid container spacing={1.5} sx={{ width: { xs: '100%', lg: 420 }, alignItems: 'stretch' }}>
                {heroHighlights.map((item) => (
                  <Grid item xs={6} key={item.label} sx={{ display: 'flex' }}>
                    <Paper
                      sx={{
                        p: 2,
                        width: '100%',
                        minHeight: 108,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        borderRadius: 3,
                        bgcolor: 'rgba(255,255,255,0.14)',
                        color: '#ffffff',
                        border: '1px solid rgba(255,255,255,0.14)',
                        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.18)'
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          minHeight: 42,
                          color: 'rgba(255,255,255,0.88)',
                          fontWeight: 600,
                          lineHeight: 1.35
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          mt: 0.5,
                          fontWeight: 800,
                          color: '#ffffff',
                          lineHeight: 1.2,
                          textShadow: '0 1px 8px rgba(15, 23, 42, 0.2)'
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </Paper>
      </motion.div>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {summaryCards.map((card) => (
          <Grid item xs={12} sm={6} lg={3} key={card.title}>
            <DepartmentSummaryCard
              title={card.title}
              value={card.value}
              helper={card.helper}
              accent={activeDepartment.accent}
              icon={card.icon}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default DeductionsOverview;
